import React, {useEffect, useState} from "react";
import Spinner from "./Spinner";
import {simpleRequest} from "../newForms2/simpleRequest";
import {sortArrayByObjectField2} from "../helpers/sort";
import {BlackWhite} from "./styledComponents/colors";
import {useSelector} from "react-redux";

const UserList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});
  const companies = useSelector(st => st.companies);

  useEffect(() => {
    const fetch = async () => {
      const data = (await simpleRequest({url: "users"})).data;
      const u = sortArrayByObjectField2(sortArrayByObjectField2(data?.users, "firstName"), "lastName");
      setUsers([...u]);
      setIsLoading(false);
    };
    if (isLoading) fetch();
  });

  if (isLoading) return <Spinner />;
  const initialList = Array.from(new Set(users.map(u => u.lastName.slice(0, 1)))).sort();

  const handleClick = e => {
    const username = e.target.parentElement.parentElement.id;
    if (!username) return;
    console.log(username);
    setUser(users.find(u => u.username === username));
  };

  return (
    <div>
      <h3>Benutzer</h3>
      <p>Dies ist eine Liste der Benutzer dieser Seite.</p>
      <p>Sie können hier keine Benutzer hinzufügen oder bearbeiten.</p>
      <p>Diese Liste ist nur da, um Benutzer schnell finden zu können.</p>
      <p>Klicken Sie auf den Benutzer, um Einzelheiten zu sehen.</p>
      <p>
        Um einen Benutzer zu bearbeiten, gehen Sie auf "Schulen", dann "Schulen", wählen Sie die Schule aus und klicken Sie dort auf
        "Benutzer"
      </p>
      {initialList.map(i => {
        return (
          <div key={i}>
            <h5>{i}</h5>
            <ul>
              {users
                .filter(u => u.lastName.slice(0, 1) === i)
                .map(u => {
                  const company = companies.find(c => u.companyId === c.id);
                  const companyName = company?.name;
                  const nameTxt = `${u.title ? `${u.title} ` : ""}${u.firstName} ${u.lastName}`;
                  const funcTxt =
                    u.functions && companyName
                      ? `${u.functions} bei: ${companyName}`
                      : companyName
                      ? companyName
                      : u.functions
                      ? u.functions
                      : "";
                  return (
                    <span key={u?.username}>
                      {user.username !== u?.username && (
                        <li key={u.username} id={u.username}>
                          <BlackWhite onClick={e => handleClick(e)}>
                            <b>{nameTxt}</b>
                          </BlackWhite>
                          {`, ${funcTxt}`}
                        </li>
                      )}
                      {user.username === u.username && (
                        <div className="p-3 my-2" style={{border: "1px solid grey", borderRadius: "5px"}}>
                          <h5>{nameTxt}</h5>
                          <h6>{funcTxt}</h6>
                          {u.phone ? <p>{`Telefon: ${u.phone}`}</p> : null}
                          {u.mobile ? <p>{`Mobil: ${u.mobile}`}</p> : null}
                          {u.email ? <p>{`Email: ${u.email}`}</p> : null}
                          {u.note ? <p>{`Notizen: ${u.note}`}</p> : null}
                        </div>
                      )}
                    </span>
                  );
                })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
export default UserList;
